import { Card } from '@cortex/web-design-system/components/ui/Card';

/** @graph-connects none */
const DEFINITIONS = [
  {
    name: '減価償却費',
    color: '#475569',
    business:
      'レンタル用アイテム（メンズ個品）の取得原価を、耐用期間にわたり費用化した月次金額。入荷日から24ヶ月の定額法で月次均等に償却する。',
    engineeringFormula: '月次償却額 = FLOOR(取得原価 / 24)\n最終月 = 取得原価 − (月次償却額 × 23)',
    engineeringSource:
      'ソース: database_no_embedding.PHOENIX_ITEM_PROD_items (item_group_id=5)\n取得原価: item_procurement_details.purchase_price（税抜下代）\n償却開始: COALESCE(procurement_shippings.arrival_date, items.stored_date)（入荷日, JST変換）\n除外: item_status IN (7=SOLD, 14=DISPOSED, 9=MISSING)',
  },
  {
    name: '廃棄原価',
    color: '#b45309',
    business:
      '品質基準を満たさなくなり廃棄処分されたアイテム、または紛失認定されたアイテムの、イベント時点の帳簿価額（簿価）。イベント日が属する月に費用計上する。',
    engineeringFormula: '廃棄原価 = 取得原価 − 累計償却額(廃棄日時点)',
    engineeringSource:
      '判定: items.item_status IN (14=DISPOSED, 9=MISSING)\n廃棄日: items.disposed_date / 紛失日: items.updated_at（JST変換）\n計上月: イベント日の属する年月',
  },
  {
    name: '販売原価',
    color: '#0f766e',
    business:
      '会員が購入転換（買取）したアイテムの、購入日時点の帳簿価額（簿価）。購入日が属する月に費用計上する。',
    engineeringFormula: '販売原価 = 取得原価 − 累計償却額(購入日時点)',
    engineeringSource:
      '判定: items.item_status = 7 (SOLD)\n購入日: phoenix_order.order_items.purchased_date\n※ phoenix_item と phoenix_order は別DB、直接JOIN不可',
  },
  {
    name: '償却残',
    color: '#1d4ed8',
    business:
      '対象月末時点で在庫として残っている全個品の帳簿価額の合計。資産としてB/Sに計上される残高に相当する。',
    engineeringFormula:
      '償却残 = Σ (取得原価 − 累計償却額)\n  対象: item_status NOT IN (7, 9, 14)\n       AND stored_date IS NOT NULL',
    engineeringSource: '検算: 前月償却残 − 当月計上合計 = 当月償却残',
  },
];

/**
 * @graph-stack ac-mens-hub
 * @graph-domain Finance
 * @graph-business Definition view showing business and engineering definitions for each cost accounting metric. Follows KpiDefinitionView pattern.
 * @graph-connects none
 */
export function CostAccountingDefinitionView() {
  return (
    <div className="mt-6 flex flex-col gap-4">
      {DEFINITIONS.map((def) => (
        <Card key={def.name} className="grid gap-6 p-5 md:grid-cols-2">
          <div className="flex items-center gap-2 border-b border-[var(--color-border)] pb-3 md:col-span-2">
            <span className="inline-block h-2 w-2 rounded-full" style={{ background: def.color }} />
            <span className="text-sm font-bold">{def.name}</span>
          </div>
          <div>
            <div className="mb-2 text-[0.625rem] font-semibold uppercase tracking-widest text-[var(--color-text-muted)]">
              ビジネス定義
            </div>
            <p className="text-sm leading-relaxed text-[var(--color-text-secondary)]">
              {def.business}
            </p>
          </div>
          <div>
            <div className="mb-2 text-[0.625rem] font-semibold uppercase tracking-widest text-[var(--color-text-muted)]">
              エンジニア定義
            </div>
            <pre className="rounded-md bg-[var(--color-bg-subtle)] px-3 py-2 font-mono text-xs leading-relaxed text-[var(--color-text-primary)]">
              {def.engineeringFormula}
            </pre>
            <p className="mt-2 whitespace-pre-line text-xs text-[var(--color-text-secondary)]">
              {def.engineeringSource}
            </p>
          </div>
        </Card>
      ))}
    </div>
  );
}
